var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('regala-hero'),_c('bottom-shape',{attrs:{"background":'rgb(103 200 200)'}}),_c('ketarim')],1)}
var staticRenderFns = []

export { render, staticRenderFns }